import { InvoiceFileFragment } from 'generated/resources/graphql'

import { UploadFile } from 'modules/expenses/components/common/DropItem'

export const convertInvoiceFileToUploadFile = (file?: InvoiceFileFragment): UploadFile | null => {
  if (!file) return null

  return {
    id: `${file.id}`,
    name: file.filename,
    size: '0',
    preview: file.url,
    type: file.contentType,
  }
}
